import { html } from "htm/preact";
import { ctx, translate } from "..";

import EnvironmentalLabelsComponent, { SortimentsFiterComponenet } from "./EnvironmentalLabelsComponent";

export default function Sidebar() {



    const { state, dispatch } = ctx();
    const categories = state.allCategories;

    const brands = Object.keys(state.products.reduce((p, n) => { p[n.brand] = true; return p; }, {}));

    const handleDropDown = ({ target }) => {
        const parentElem = (target as HTMLElement).parentElement!
        parentElem.classList.toggle('selected');
        (target as HTMLElement).classList.toggle('reversed');
    }

    //    const categories = Object.keys(state.products.reduce((p, n) => { p[n.category] = true; return p; }, {}));

    return html`<div class="sidebar-detached sidebar-left position-fixed">
    <div class="sidebar">
        <!-- Ecommerce Sidebar Starts -->
        <div class="sidebar-shop">
            <div class="row">
                <div class="col-sm-12">
                    <h6 class="filter-heading d-none d-lg-block">${translate('Filters')}</h6>
                </div>
            </div>
            <div class="card pt-0 overflow-auto" style="max-height: 83vh">
                <div class="card-body">
                    <!-- Price Filter starts -
                    <div class="multi-range-price">
                        <h6 class="filter-title mt-0">Multi Range</h6>
                        <ul class="list-unstyled price-range" id="price-range">
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceAll" name="price-range" class="form-check-input"
                                        checked="" />
                                    <label class="form-check-label" for="priceAll">All</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange1" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange1">&lt;=$10</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange2" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange2">$10 - $100</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceARange3" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceARange3">$100 - $500</label>
                                </div>
                            </li>
                            <li>
                                <div class="form-check">
                                    <input type="radio" id="priceRange4" name="price-range" class="form-check-input" />
                                    <label class="form-check-label" for="priceRange4">&gt;= $500</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- Price Filter ends -->

                    <!-- Price Slider starts 
                    <div class="price-slider">
                        <h6 class="filter-title">Price Range</h6>
                        <div class="price-slider">
                            <div class="range-slider mt-2 noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr"
                                id="price-slider">
                                <div class="noUi-base">
                                    <div class="noUi-connects">
                                        <div class="noUi-connect"
                                            style="transform: translate(29.2786%, 0px) scale(0.404122, 1);">
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-707.214%, 0px); z-index: 5;">
                                        <div class="noUi-handle noUi-handle-lower" data-handle="0" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="51.0"
                                            aria-valuemax="3500.0" aria-valuenow="1500.0" aria-valuetext="1500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">1500</div>
                                        </div>
                                    </div>
                                    <div class="noUi-origin" style="transform: translate(-303.092%, 0px); z-index: 4;">
                                        <div class="noUi-handle noUi-handle-upper" data-handle="1" tabindex="0"
                                            role="slider" aria-orientation="horizontal" aria-valuemin="1500.0"
                                            aria-valuemax="5000.0" aria-valuenow="3500.0" aria-valuetext="3500">
                                            <div class="noUi-touch-area"></div>
                                            <div class="noUi-tooltip">3500</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Price Range ends -->
                    <div id="clear-filters">
                        <button onclick=${() => { dispatch({ type: 'filter.clear' }); }} type="button" class="btn w-100 btn-primary waves-effect waves-float waves-light">${translate('Clear filters')}</button>
                    </div>
                    <${SortimentsFiterComponenet} />
                    <!-- Categories Starts -->
                    <div id="product-categories">
                        <h6 class="filter-title">${translate('Categories')}</h6>
                        <ul class="list-unstyled categories-list">
                            ${categories.filter(it => !it.parent).map(category => html`<li>
                                <div  onclick=${ev => dispatch({ type: 'toggleCategory', category })} class="form-check parent-category"  >
                                    <div class="parent-cat"><input type="checkbox" name="category-filter" class="form-check-input"
                                    checked=${Boolean(state.categories.find(c => c.name == category.name))} />
                                <label class="form-check-label" for="category1">${category.name}</label><span class="dropdown-icon" onClick=${e => { e.stopImmediatePropagation(); handleDropDown(e) }}></span></div>
                                    ${categories.filter(sub1 => sub1.parent == category.name).map(sub1 => html`<li>
                                        <div onclick=${ev => { ev.stopImmediatePropagation(); dispatch({ type: 'toggleCategory', category: sub1 }) }} class="form-check parent-category"  >
                                            <div class="parent-cat"><input type="checkbox" name="category-filter" class="form-check-input"
                                            checked=${Boolean(state.categories.find(c => c.name == sub1.name))} />
                                        <label class="form-check-label" for="category1">${sub1.name}</label><span class="dropdown-icon" onClick=${e => { e.stopImmediatePropagation(); handleDropDown(e) }}></span></div>

                                            ${categories.filter(sub2 => sub2.parent == sub1.name).map(sub2 => html`<li>
                                            <div onclick=${ev => { ev.stopImmediatePropagation(); dispatch({ type: 'toggleCategory', category: sub2 }) }} class="form-check parent-category"  >
                                                <input type="checkbox" name="category-filter" class="form-check-input"
                                                checked=${Boolean(state.categories.find(c => c.name == sub2.name))} />
                                            <label class="form-check-label" for="category1">${sub2.name}</label>
                                            </div>
                                        </li>`)}
                                        </div>
                                    </li>`)}
                                </div>
                            </li>`)}
                        </ul>
                    </div>
                    <!-- Categories Ends -->
                    <${EnvironmentalLabelsComponent} />

                    <!-- Clear Filters Starts -->
                    
                    <!-- Clear Filters Ends -->
                </div>
            </div>
        </div>
        <!-- Ecommerce Sidebar Ends -->

    </div>
</div>`;
}